import React from 'react';

import { ApiCommodityType, ApiMarketType, useGetAllAsset, useGetInfo } from '@ping/api';
import { isListedMarket } from '@ping/helpers/access-scope.helper';
import { selectedMarketInstrumentSelector, useMarketStore } from '@ping/stores/market.store';

export function useIsSelectedMarketNftCommodity() {
  const instrument = useMarketStore(selectedMarketInstrumentSelector);
  const { data: marketInfo } = useGetInfo();
  const { data: allAssets } = useGetAllAsset();

  return React.useMemo(() => {
    if (!marketInfo?.pairs || !instrument || !allAssets?.data) {
      return false;
    }

    const market = marketInfo.pairs[instrument];
    const asset = allAssets?.data.find(asset => asset.id === market?.baseAsset);
    if (!asset) {
      return false;
    }

    const isHidden = !isListedMarket(market ?? {});
    const isCommodity = asset?.type === ApiMarketType.Commodity;
    const isNftCommodity =
      asset?.commodity_asset?.commodity_type === ApiCommodityType.NonFractionalNFT ||
      asset?.commodity_asset?.commodity_type === ApiCommodityType.FractionalNFT;

    return isCommodity && isNftCommodity && !isHidden;
  }, [marketInfo, allAssets, instrument]);
}
